/**
 * Development-only tracing. Uses NODE_ENV === 'development' so production
 * bundles can drop the branch; no-op under Vitest (NODE_ENV=test).
 */

export function isDevDebugEnabled(): boolean {
	return process.env.NODE_ENV === 'development';
}

/** Forwards to console.debug only in development; no-op otherwise. */
export function devDebug(...args: unknown[]): void {
	if (process.env.NODE_ENV === 'development') {
		console.debug(...args);
	}
}
